module.exports = __webpack_public_path__ + "img/resp-mobile.1bf20b91.svg";